export default "<router-outlet></router-outlet>\r\n\r\n<!-- <hour4u-admin-vocallabs-support-widget></hour4u-admin-vocallabs-support-widget> -->"